import axios from "axios";

const api = axios.create({
  // baseURL: "https://localhost:5001/api/", //44370/", // LOCALHOST   
  baseURL: "https://whats.nafil.com.br/api/",      // SITE ON LINE LINUX 
  withCredentials: true  
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token"); // ou cookie
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.defaults.headers.common['X-Frontend-IP'] = '208.113.133.18'; // IP do Local Hospedado o FrontEnd
export default api;